// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#chart{margin-top:20px}.legend-container{display:flex;gap:10px;margin-bottom:10px}.legend-item{cursor:pointer;font-size:14px;display:flex;align-items:center}.legend-color{width:12px;height:12px;border-radius:50%;display:inline-block;margin-right:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
